import type { GetThreadsParams, HomeTabs, ReplyThreadParams } from '@/types/thread';

import router from '../router';
import httpClient from '../utils/httpClient';

export default {
  async getThreadsList(params: GetThreadsParams, tabName: HomeTabs) {
    const tabUrls = new Map([
      ['all', '/api/emails/threads'],
      ['sent', '/api/emails/sent'],
      ['trash', '/api/emails/threads?in_trash=true']
    ]);

    const url = tabUrls.get(tabName) ?? false;
    if (!url) return;
    const { data } = await httpClient.get(url, {
      params
    });

    return data;
  },
  async getMessagesList() {
    const uuid = router.currentRoute.value.params.uuid as string;
    const { data } = await httpClient.get(`/api/emails/threads/${uuid}`);

    return data;
  },
  async deleteThread() {
    const uuid = router.currentRoute.value.params.uuid as string;
    await httpClient.post(`/api/emails/threads/${uuid}/move_to_trash`);
  },
  async moveBackToInbox(uuid: string) {
    return await httpClient.post(`/api/emails/threads/${uuid}/move_to_inbox`);
  },
  async toggleStarValue(starred: boolean, uuid?: string) {
    const uuidParam = uuid ?? router.currentRoute.value.params.uuid as string;

    return await httpClient.post(`/api/emails/threads/${uuidParam}/set_starred`, {
      starred
    });
  },
  async markThreadAsRead(uuid: string) {
    const { data } = await httpClient.post(`/api/emails/${uuid}/mark_as_read`);

    return data;
  },
  async postReplyThread(paramsData: ReplyThreadParams) {
    const { data } = await httpClient.post(`/api/emails/${paramsData.uuid}/reply`, {
      body_html: paramsData.bodyHtml,
      attachments: paramsData.attachments,
      to: paramsData.to,
      cc: paramsData.cc
    });

    return data;
  },
  async getSupportedVariables() {
    const { data } = await httpClient.get('/api/emails/variables');

    return data;
  },
  async getDefaultRecipients(uuid: string) {
    const { data } = await httpClient.get(`/api/emails/${uuid}/default_reply_recipients`);

    return data;
  }
};
